import hljs from 'highlight.js';

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Highlight.js
  hljs.highlightAll();

  // Iterate over each pre element to add wrapping and the copy button
  document.querySelectorAll('pre').forEach((preElement) => {
    // Create a wrapper div for the code container
    const codeContainer = document.createElement('div');
    codeContainer.className = 'code-container';

    // Create a copy button
    const copyButton = document.createElement('button');
    copyButton.className = 'copy-button';
    copyButton.textContent = 'Copy';
    codeContainer.appendChild(copyButton);

    // Insert the code container before the pre element in the DOM
    preElement.parentNode.insertBefore(codeContainer, preElement);

    // Move the pre element inside the code container
    codeContainer.appendChild(preElement);

    // Copy button functionality
    copyButton.addEventListener('click', function() {
      const codeElement = preElement.querySelector('code');
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(codeElement);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
      copyButton.textContent = 'Copied!';
      setTimeout(() => copyButton.textContent = 'Copy', 2000);
    });
  });
});
